<template>
  <div class="training-group-form"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="form-container">
      <el-form ref="form"
               :model="formData"
               :rules="rules"
               label-width="100px"
               size="mini">
        <!-- 教学点 -->
        <el-form-item label="教学点" prop="siteId">
          <el-select v-model="formData.siteId"
                     placeholder="请选择教学点"
                     filterable
                     :disabled="isEdit"
                     size="mini"
                     style="width: 100%"
                     @change="handleSiteChange">
            <el-option v-for="site in siteList"
                       :key="site.id"
                       :label="site.name"
                       :value="site.id">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 班级 -->
        <el-form-item label="班级" prop="classId">
          <el-select v-model="formData.classId"
                     placeholder="请选择班级"
                     filterable
                     size="mini"
                     style="width: 100%"
                     @change="handleClassChange">
            <el-option v-for="cls in classList"
                       :key="cls.id"
                       :label="cls.name"
                       :value="cls.id">
            </el-option>
            <div v-if="classList.length === 0" slot="empty" style="padding: 10px 0; text-align: center; color: #999;">
              {{ formData.siteId ? '暂无班级' : '请先选择教学点' }}
            </div>
          </el-select>
        </el-form-item>

        <!-- 课程 -->
        <el-form-item label="课程" prop="courseId">
          <el-select v-model="formData.courseId"
                     placeholder="请选择课程"
                     filterable
                     size="mini"
                     style="width: 100%">
            <el-option v-for="course in courseList"
                       :key="course.id"
                       :label="course.name"
                       :value="course.id">
            </el-option>
            <div v-if="courseList.length === 0" slot="empty" style="padding: 10px 0; text-align: center; color: #999;">
              {{ formData.classId ? '暂无课程' : '请先选择班级' }}
            </div>
          </el-select>
        </el-form-item>

        <!-- 小组编号 -->
        <el-form-item label="小组编号" prop="groupNo">
          <el-input v-model="formData.groupNo"
                    placeholder="请输入小组编号"
                    size="mini"
                    maxlength="50">
          </el-input>
        </el-form-item>

        <!-- 小组名称 -->
        <el-form-item label="小组名称" prop="groupName">
          <el-input v-model="formData.groupName"
                    placeholder="请输入小组名称"
                    size="mini"
                    maxlength="100">
          </el-input>
        </el-form-item>

        <!-- 指导导师 -->
        <el-form-item label="指导导师" prop="tutorId">
          <el-select v-model="formData.tutorId"
                     placeholder="请选择指导导师"
                     filterable
                     clearable
                     size="mini"
                     style="width: 100%">
            <el-option v-for="teacher in tutorList"
                       :key="teacher.id"
                       :label="teacher.name"
                       :value="teacher.id">
            </el-option>
            <div v-if="tutorList.length === 0" slot="empty" style="padding: 10px 0; text-align: center; color: #999;">
              {{ formData.siteId ? '暂无导师' : '请先选择教学点' }}
            </div>
          </el-select>
        </el-form-item>

        <!-- 预审专家 -->
        <el-form-item label="预审专家" prop="expertId">
          <el-select v-model="formData.expertId"
                     placeholder="请选择预审专家"
                     filterable
                     clearable
                     size="mini"
                     style="width: 100%">
            <el-option v-for="teacher in expertList"
                       :key="teacher.id"
                       :label="teacher.name"
                       :value="teacher.id">
            </el-option>
            <div v-if="expertList.length === 0" slot="empty" style="padding: 10px 0; text-align: center; color: #999;">
              {{ formData.siteId ? '暂无专家' : '请先选择教学点' }}
            </div>
          </el-select>
        </el-form-item>
      </el-form>

      <!-- 操作按钮 -->
      <div class="footer-btns">
        <el-button size="mini" @click="handleCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="handleSubmit" :loading="submitting">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainingGroupForm',
  props: {
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      submitting: false,
      isEdit: false,
      groupId: '',
      batchId: '',
      siteList: [],
      classList: [],
      courseList: [],
      tutorList: [],
      expertList: [],
      formData: {
        siteId: '',
        classId: '',
        courseId: '',
        groupNo: '',
        groupName: '',
        tutorId: '',
        expertId: ''
      },
      rules: {
        siteId: [
          {required: true, message: '请选择教学点', trigger: 'change'}
        ],
        classId: [
          {required: true, message: '请选择班级', trigger: 'change'}
        ],
        courseId: [
          {required: true, message: '请选择课程', trigger: 'change'}
        ],
        groupNo: [
          {required: true, message: '请输入小组编号', trigger: 'blur'}
        ],
        groupName: [
          {required: true, message: '请输入小组名称', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    loadData () {
      console.log('[loadData] isEdit:', this.isEdit, 'groupId:', this.groupId)
      this.loadSiteList()
      if (this.isEdit && this.groupId) {
        console.log('[loadData] 调用 loadGroupDetail')
        this.loadGroupDetail()
      } else {
        console.log('[loadData] 跳过 loadGroupDetail')
      }
    },
    loadSiteList () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/training/group/getSiteList',
        method: 'post',
        data: this.$qs.stringify({
          batchId: this.batchId
        })
      }).then(response => {
        if (response.data) {
          if (response.data.responseCode === 'SUCCESS') {
            this.siteList = response.data.data || []
          } else {
            this.$message.warning(response.data.message)
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    async loadGroupDetail () {
      console.log('[loadGroupDetail] 开始执行, groupId:', this.groupId)
      // 添加场景不发送请求
      if (!this.groupId) {
        console.log('[loadGroupDetail] groupId 为空，直接返回')
        return
      }
      console.log('[loadGroupDetail] 发送请求')
      this.loading = true
      try {
        const response = await this.$ajax({
          url: '/workspace/manager/training/group/getGroupDetail',
          method: 'post',
          data: this.$qs.stringify({
            groupId: this.groupId
          })
        })
        if (response.data) {
          if (response.data.responseCode === 'SUCCESS') {
            const data = response.data.data || {}
            // 先加载级联数据，再回显表单数据
            if (data.siteId) {
              // 等待级联数据加载完成
              await this.loadCascadeDataAsync(data.siteId, data.classId)
            }
            // 级联数据加载完成后，再回显表单数据
            this.formData.siteId = data.siteId || ''
            this.formData.classId = data.classId || ''
            this.formData.courseId = data.courseId || ''
            this.formData.groupNo = data.groupNo || ''
            this.formData.groupName = data.groupName || ''
            this.formData.tutorId = data.tutorId || ''
            this.formData.expertId = data.expertId || ''
          } else {
            this.$message.warning(response.data.message)
          }
        }
      } catch (error) {
        this.$message.error('请求发送失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleSiteChange (siteId) {
      // 清空级联数据
      this.formData.classId = ''
      this.formData.courseId = ''
      this.formData.tutorId = ''
      this.formData.expertId = ''
      this.classList = []
      this.courseList = []
      this.tutorList = []
      this.expertList = []
      if (siteId) {
        this.loadCascadeData(siteId)
      }
    },
    handleClassChange (classId) {
      // 清空课程
      this.formData.courseId = ''
      this.courseList = []
      if (classId) {
        this.loadCourseList(classId)
      }
    },
    loadCascadeData (siteId) {
      // 并行加载班级、导师、专家
      this.loadClassList(siteId)
      this.loadTeacherList(siteId)
    },
    // 异步加载级联数据（用于回显时等待数据加载完成）
    async loadCascadeDataAsync (siteId, classId) {
      // 并行加载班级和教师
      await Promise.all([
        this.loadClassListAsync(siteId),
        this.loadTeacherListAsync(siteId)
      ])
      // 如果有班级ID，加载课程列表
      if (classId) {
        await this.loadCourseListAsync(classId)
      }
    },
    loadClassList (siteId) {
      this.$ajax({
        url: '/workspace/manager/training/group/getClassesBySite',
        method: 'post',
        data: this.$qs.stringify({
          batchId: this.batchId,
          siteId: siteId
        })
      }).then(response => {
        if (response.data && response.data.responseCode === 'SUCCESS') {
          this.classList = response.data.data || []
          // 回显时检查班级是否在列表中，不在则清空
          if (this.formData.classId && !this.classList.find(c => c.id === this.formData.classId)) {
            console.log('[loadClassList] 班级不在列表中，清空')
            this.formData.classId = ''
          }
          // 如果有班级ID，加载课程列表
          if (this.formData.classId) {
            this.loadCourseList(this.formData.classId)
          }
        }
      })
    },
    async loadClassListAsync (siteId) {
      const response = await this.$ajax({
        url: '/workspace/manager/training/group/getClassesBySite',
        method: 'post',
        data: this.$qs.stringify({
          batchId: this.batchId,
          siteId: siteId
        })
      })
      if (response.data && response.data.responseCode === 'SUCCESS') {
        this.classList = response.data.data || []
      }
    },
    loadCourseList (classId) {
      this.$ajax({
        url: '/workspace/manager/training/group/getCoursesByClass',
        method: 'post',
        data: this.$qs.stringify({
          classId: classId
        })
      }).then(response => {
        if (response.data && response.data.responseCode === 'SUCCESS') {
          this.courseList = response.data.data || []
          // 回显时检查课程是否在列表中，不在则清空
          if (this.formData.courseId && !this.courseList.find(c => c.id === this.formData.courseId)) {
            console.log('[loadCourseList] 课程不在列表中，清空')
            this.formData.courseId = ''
          }
        }
      })
    },
    async loadCourseListAsync (classId) {
      const response = await this.$ajax({
        url: '/workspace/manager/training/group/getCoursesByClass',
        method: 'post',
        data: this.$qs.stringify({
          classId: classId
        })
      })
      if (response.data && response.data.responseCode === 'SUCCESS') {
        this.courseList = response.data.data || []
      }
    },
    loadTeacherList (siteId) {
      this.$ajax({
        url: '/workspace/manager/training/group/getTeachersBySite',
        method: 'post',
        data: this.$qs.stringify({
          batchId: this.batchId,
          siteId: siteId
        })
      }).then(response => {
        if (response.data && response.data.responseCode === 'SUCCESS') {
          const teachers = response.data.data || []
          // 导师和专家使用同一个教师列表
          this.tutorList = teachers
          this.expertList = teachers
          // 回显时检查导师和专家是否在列表中，不在则清空
          if (this.formData.tutorId && !this.tutorList.find(t => t.id === this.formData.tutorId)) {
            console.log('[loadTeacherList] 导师不在列表中，清空')
            this.formData.tutorId = ''
          }
          if (this.formData.expertId && !this.expertList.find(t => t.id === this.formData.expertId)) {
            console.log('[loadTeacherList] 专家不在列表中，清空')
            this.formData.expertId = ''
          }
        }
      })
    },
    async loadTeacherListAsync (siteId) {
      const response = await this.$ajax({
        url: '/workspace/manager/training/group/getTeachersBySite',
        method: 'post',
        data: this.$qs.stringify({
          batchId: this.batchId,
          siteId: siteId
        })
      })
      if (response.data && response.data.responseCode === 'SUCCESS') {
        const teachers = response.data.data || []
        // 导师和专家使用同一个教师列表
        this.tutorList = teachers
        this.expertList = teachers
      }
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false
        }
        this.submitForm()
      })
    },
    submitForm () {
      this.submitting = true
      this.$ajax({
        url: '/workspace/manager/training/group/saveGroup',
        method: 'post',
        data: this.$qs.stringify({
          groupId: this.groupId || '',
          batchId: this.batchId,
          siteId: this.formData.siteId,
          classId: this.formData.classId,
          courseId: this.formData.courseId,
          groupNo: this.formData.groupNo,
          groupName: this.formData.groupName,
          tutorId: this.formData.tutorId || '',
          expertId: this.formData.expertId || ''
        })
      }).then(response => {
        if (response.data) {
          if (response.data.responseCode === 'SUCCESS') {
            this.$message.success(response.data.data || '保存成功')
            this.$emit('hidePopoverAndRefresh')
          } else {
            this.$message.warning(response.data.message)
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.submitting = false
      })
    },
    handleCancel () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    console.log(this.$attrs)
    // 获取参数
    this.batchId = (this.extraParams && this.extraParams.batchId) || ''
    // extra-id 可能是空数组，需要特殊处理
    let extraId = this.$attrs['extra-id']
    this.groupId = (Array.isArray(extraId) && extraId.length === 0) ? '' : (extraId || '')
    this.isEdit = !!this.groupId
    console.log('[mounted] batchId:', this.batchId, 'groupId:', this.groupId, 'isEdit:', this.isEdit)
    console.log('[mounted] $attrs:', this.$attrs)
    this.loadData()
  },
  watch: {
    visible: function (val) {
      console.log('[watch visible]', val)
      if (val) {
        // 重新获取参数，避免使用上次的值
        this.batchId = (this.extraParams && this.extraParams.batchId) || ''
        // extra-id 可能是空数组，需要特殊处理
        let extraId = this.$attrs['extra-id']
        this.groupId = (Array.isArray(extraId) && extraId.length === 0) ? '' : (extraId || '')
        this.isEdit = !!this.groupId
        console.log('[watch visible] 重新获取参数 - batchId:', this.batchId, 'groupId:', this.groupId, 'isEdit:', this.isEdit)
        console.log('[watch visible] $attrs:', this.$attrs)
        // 重置表单数据
        this.formData = {
          siteId: '',
          classId: '',
          courseId: '',
          groupNo: '',
          groupName: '',
          tutorId: '',
          expertId: ''
        }
        // 清空级联数据
        this.classList = []
        this.courseList = []
        this.tutorList = []
        this.expertList = []
        // 清空表单验证
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
        this.loadData()
      }
    }
  }
}
</script>

<style lang="scss">
.training-group-form {
  width: 100%;
  height: 100%;
  padding: 20px;
  padding-right: 50px;
  .form-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-form {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .footer-btns {
      padding-top: 20px;
      border-top: 1px solid #eee;
      text-align: right;
    }
  }
}
</style>
